export default __webpack_public_path__ + "3818a7025e35cbceafa9a3ba3210ce2b.jpg";